module.exports = __webpack_public_path__ + "static/media/mobile_archero2_page_area01_img_en@2x.2c37a374.png";